import type { CreateJobInput, UpdateJobInput } from '@chukua/common';
import type { UploadView } from '../../components/uploads.api';
import { api } from '../../lib/api';

export interface JobView {
  id: string;
  number: string;
  customerId: string;
  jobTypeCode: string;
  originZoneCode: string | null;
  destinationZoneCode: string | null;
  requestedDate: string | null;
  customerDeliveryDeadline: string | null;
  status: string;
  heldFromStatus: string | null;
  source: string | null;
  contactName: string | null;
  contactPhone: string | null;
  requestedQuantity: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface JobDetail extends JobView {
  attachments: UploadView[];
}

export function createJob(input: CreateJobInput): Promise<JobView> {
  return api<JobView>('/jobs', { method: 'POST', body: JSON.stringify(input) });
}

export function getJob(id: string): Promise<JobDetail> {
  return api<JobDetail>(`/jobs/${id}`);
}

export function updateJob(id: string, input: UpdateJobInput): Promise<JobView> {
  return api<JobView>(`/jobs/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}
